var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import { Link } from 'react-router-dom';
import Card from 'antd/lib/card';
import Col from 'antd/lib/col';
import Row from 'antd/lib/row';
import 'antd/lib/card/style/index.css';
import 'antd/lib/grid/style/index.css';
import ButtonAction from '../components/utilities/ButtonAction';
var cardStyles = require('src/imports/styles/extend.card.scss');
var CardOnboard = (function (_super) {
    __extends(CardOnboard, _super);
    function CardOnboard() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CardOnboard.prototype.render = function () {
        return (React.createElement(Card, { className: this.props.className },
            React.createElement("h2", { className: cardStyles.header }, "Let's get you started"),
            React.createElement("p", null,
                "Welcome to the organizer dashboard for CRIMP! You and your team will manage your event data, judges, athletes and scores from here. For your judges, we have an ",
                React.createElement("a", { href: 'https://itunes.apple.com/us/app/crimp/id1299220607?mt=8', target: '_blank' }, "iOS"),
                " and ",
                React.createElement("a", { href: 'https://play.google.com/store/apps/details?id=rocks.crimp.main.android', target: '_blank' }, "Android"),
                " app for them to submit scores to here."),
            React.createElement("p", null,
                "We hope that CRIMP will be useful for climbing event organizers and judges. We're always looking to improve CRIMP; if you have any suggestions or feedback, please email us at ",
                React.createElement("a", { href: 'mailto:hello@crimp.rocks' }, "hello@crimp.rocks"),
                "."),
            React.createElement("p", null, "Let's start by creating a new climbing event or joining an existing one."),
            React.createElement(Row, { gutter: 16 },
                React.createElement(Col, { xs: 24, md: 12 },
                    React.createElement(ButtonAction, null,
                        React.createElement(Link, { to: '/event/new' }, "Create Event"))),
                React.createElement(Col, { xs: 24, md: 12 },
                    React.createElement(ButtonAction, null,
                        React.createElement("button", { onClick: this.props.handleShowCardJoin }, "Join Events"))))));
    };
    return CardOnboard;
}(React.Component));
export default CardOnboard;



//////////////////
// WEBPACK FOOTER
// ./src/pages/PageWelcome/CardOnboard.tsx
// module id = 824
// module chunks = 0